import React from "react";
import styled from "styled-components";
import {useLocation} from "react-router";
import {tabBackgroundColour, tableBorderColour} from "../../../style/styleConsts";

import {useDispatch, useSelector} from "react-redux";
import {logAction} from "../../../logging/logEvent";
import {hideNotifications} from "../../notification/notificationActions";
import {NavItem} from "./NavItem";

function getClassName(locationPrefix, pathName, isHomepage) {
    const captureHomepage = isHomepage && pathName === "/";
    const matchesLocation = captureHomepage || pathName.startsWith(locationPrefix);
    return matchesLocation ? "current" : "";
}

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    padding: 0 18px;
    background-color: ${tabBackgroundColour};
    border-bottom: 1px solid ${tableBorderColour};
`;

const NavContainer = styled.nav`
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    -webkit-font-smoothing: antialiased;
`;


const Nav = ({}) => {
    const {pathname} = useLocation();
    const userRole = useSelector(state => state.userIdentity.userRole);
    const dispatch = useDispatch();

    function onNavigationItemClick(userAction) {
        return (ignoredEvent) => {
            dispatch(hideNotifications());
            logAction({type: userAction});
        }
    }

    let myIdeas = null;
    let homePageIsStocks = true;
    if (userRole === 'AUTHOR') {
        myIdeas = <NavItem name="ideas"
                           className={getClassName("/contribute", pathname, true)}
                           onClick={onNavigationItemClick("MY_IDEAS_TAB_CLICKED")}
                           to="/contribute" exact>My Ideas</NavItem>;
        homePageIsStocks = false;
    }

    return (
        <Wrapper>
            <NavContainer>
                {myIdeas}
                <NavItem name="stocks"
                         className={getClassName("/stock", pathname, homePageIsStocks)}
                         onClick={onNavigationItemClick("STOCKS_AND_SECTORS_CLICKED")}
                         to="/stocks">
                    Stocks &amp; Sectors
                </NavItem>
                <NavItem name="ourProgramme"
                         className={getClassName("/our-programme", pathname, false)}
                         onClick={onNavigationItemClick("OUR_PROGRAMME_TAB_CLICKED")}
                         to="/our-programme">
                    Our Programme
                </NavItem>
            </NavContainer>
        </Wrapper>
    );
};

export default Nav;